<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-16 15:22:20
 * @LastEditors: sen.yang
 * @LastEditTime: 2021-12-22 16:36:53
-->
<template>
  <div class="popup-item-row">
      <div class="popup-item-content" :class="border?'border':''">
          <div style="flex:1" @click="$emit('click')">
            <div >
                <span class="tag-address" v-if="defaultAddress" >默认地址</span><span class="text">{{address}}</span>
            </div>
            <div class="label">{{name}} {{phone}}</div>
          </div>
          <div class="change-icon" @click="$emit('bntClick')"></div>
      </div>
  </div>
</template>

<script>
export default {
    props:{
        border:{
            type:Boolean,
            default:true
        },
        defaultAddress:{
            type:[String,Number],
            default:''
        },
        name:{
            type:String,
            default:''
        },
        phone:{
            type:[String,String],
            default:''
        },
        address:{
             type:String,
            default:''
        }
    }
}
</script>

<style scoped>
.popup-item-row{
    padding: 0 3.7vw;
}
.popup-item-content{
    padding: 4.5vw 0;
    display: flex;
}
.border{
    border-top: 1px solid #EDEFF0;
}
.tag-address{
    display: inline-block;
    margin-right: 1.6vw;
    padding: .5vw 1vw;
    color: #00BCD1;
    background-color:rgba(0, 188, 209, .1) ;
    font-size: 2.4vw;
    line-height: 4vw;
    border-radius: .3vw;
    /* transform:scale(.8); */
}
.popup-item-content .text{
    font-size: 4.2vw;
    color: #202020;
    font-weight: bold;
}
.popup-item-content{
    vertical-align: sub;
}
.popup-item-content .label{
    color:#999999;
    font-size: 3.4vw;
    margin-top: 2.1vw;
}
.change-icon{
    width: 4vw ;
    background-image: url('../../../assets/pickupchange.png');
    background-size:4vw 4vw;
    background-repeat: no-repeat;
    background-position: center center;

}
</style>


// WEBPACK FOOTER //
// src/views/address/components/PopupItem.vue